import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { useFragment } from "react-relay";
import { useSearchParams } from "react-router-dom";
import { showAnswersButton_LearnOpportunityFragment$key } from "@generated/showAnswersButton_LearnOpportunityFragment.graphql";
import { SHOW_ANSWER_BUTTON_FRAGMENT } from "./show-answers-button.graphql";
import { Container, Label } from "./show-answers-button.styles";
import { ShowAnswersButtonProps } from "./show-answers-button.types";
import { PrimaryButton } from "../../../../infecto-lms-webapp/components/buttons/PrimaryButton";
import { ShowAnswersDialog } from "../../../../infecto-lms-webapp/components/content-element/multiplechoice/ShowAnswersDialog";
import { formatDateTime } from "../../../../infecto-lms-webapp/components/DateTimeDisplay.component";
import { LockIcon } from "../../nodecard/SvgNodeIcons.component";

export function ShowAnswersButton({
	learnOpportunityFragmentRef,
	disabled,
	isContentSubmissionScreen,
}: ShowAnswersButtonProps) {
	const learnOpportunity = useFragment<showAnswersButton_LearnOpportunityFragment$key>(
		SHOW_ANSWER_BUTTON_FRAGMENT,
		learnOpportunityFragmentRef,
	);
	const [params] = useSearchParams();
	const showAnswers = params.get("show");
	const multipleChoiceElements = learnOpportunity.typeDefinition.showAnswerElements
		? learnOpportunity.typeDefinition.showAnswerElements?.filter(
				(e) => e.elementType == "multipleChoice",
			)
		: [];

	const [isShowAnswersDialogVisible, setIsShowAnswersDialogVisible] = useState(false);
	const isShowingAnswerButtonInNodeScreen =
		multipleChoiceElements.length > 0 &&
		learnOpportunity.root?.structureDefinition.extension?.configConsequences?.showAnswerExpired;
	useEffect(() => {
		if (
			learnOpportunity.typeDefinition.definitionType == "content" &&
			showAnswers &&
			multipleChoiceElements.length > 0 &&
			learnOpportunity.root?.structureDefinition.extension?.configConsequences?.showAnswerExpired
		)
			return setIsShowAnswersDialogVisible(true);
	}, []);

	if (
		learnOpportunity.typeDefinition.definitionType !== "content" ||
		(multipleChoiceElements.length <= 0 &&
			learnOpportunity.root?.structureDefinition.extension?.configConsequences?.showAnswerExpired)
	)
		return null;

	return (
		<Container className="my-2">
			{isContentSubmissionScreen ? (
				<div>
					<Button
						disabled={disabled}
						color={"black"}
						className="text-black-alpha-90 p-3 p-button-outlined p-button-secondary bg-white w-full"
						onClick={() => {
							setIsShowAnswersDialogVisible(true);
						}}
					>
						<div className="w-full text-center flex align-items-center justify-content-center">
							<Label className="mr-1">
                                {learnOpportunity?.root?.structureDefinition.extension?.configConsequences	// eslint-disable-line
									?.showAnswerFrom! && disabled
									? `Lösungen anzeigen ab 
					${formatDateTime(learnOpportunity?.root?.structureDefinition.extension?.configConsequences?.showAnswerFrom!, false)}` // eslint-disable-line
									: "Lösungen anzeigen"}
							</Label>

							{disabled ? <LockIcon widthIcon={20} heightIcon={20} /> : null}
						</div>
					</Button>{" "}
				</div>
			) : (
				<div className="my-4 md:my-0 w-full flex flex-row align-items-end justify-content-center md:justify-content-end pr-3">
					{isShowingAnswerButtonInNodeScreen ? (
						<PrimaryButton
							label={"LÖSUNGEN ANZEIGEN"}
							onClick={() => {
								setIsShowAnswersDialogVisible(true);
							}}
						/>
					) : (
						<div></div>
					)}
				</div>
			)}

			<ShowAnswersDialog
				isVisible={isShowAnswersDialogVisible}
				onHideDialog={() => setIsShowAnswersDialogVisible(false)}
				elements={multipleChoiceElements}
			/>
		</Container>
	);
}
